<template>
	<div class="welcome-page">
		<!-- <img src="@/assets/logo.png" alt="" class="logo" /> -->
		<!-- <div class="image"></div> -->
		<div class="banner-suarez">
			<div class="suarez"></div>
			<div class="bg">
				<div class="content">
					<img src="@/assets/img/banner-suarez-content.png" alt="" class="img-fluid" />
					<div class="px-4">
						<router-link tag="a" to="/login" class="btn btn-block btn-primary">Ingresar</router-link>
						<router-link tag="a" to="/register" class="btn btn-block btn-primary mt-3">Registrarme</router-link>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	name: 'SplashScreen',
}
</script>

<style scoped>
.banner-suarez {
	position: relative;
	display: inline-block;
}
.banner-suarez .bg {
	width: 100vw;
	height: 60vh;
	margin-top: 40vh;
	background-color: #fff;
	position: relative;
}
.banner-suarez .bg:before {
	content: '';
	position: absolute;
	top: -50px;
	left: 0px;
	width: 0;
	height: 0;
	border-style: solid;
	border-width: 0 0 50px 100vw;
	border-color: transparent transparent #ffffff transparent;
}

.banner-suarez .suarez {
	width: 100%;
	height: 70vh;
	position: absolute;
	top: 0;
	left: 0;
	background-image: url('~@/assets/img/banner-suarez.png');
	background-size: contain;
	background-position: center;
	background-repeat: no-repeat;
}
.banner-suarez .content {
	width: 100%;
	max-width: 400px;
	margin: auto;
}

.welcome-page {
	width: 100%;
	height: 100vh;

	margin: auto;

	display: flex;
	flex-direction: column;

	justify-content: space-between;
	/* padding: 64px 32px; */

	background-image: url('~@/assets/img/banner-suarez-bg.png');
	background-size: cover;
	background-position: center center;
}
.logo {
	width: 120px;
}
.image {
	width: 100%;

	background-image: url('~@/assets/img/suarez-banner-full.png');
	background-size: contain;
	background-position: center top;
	background-repeat: no-repeat;
}

h1 {
	font-size: 22pt;
}
</style>
